import { createSelector } from '@reduxjs/toolkit';
import { ColorItem } from '../slices/colors';
import { selectTagsByClusterId } from '../slices/tags';
import { sortAlphaBeta } from '../utils';
import { getColorWithHash } from '../utils/colors';

export const selectSortedTags = createSelector([selectTagsByClusterId], (tagsByClusterId) =>
  Object.values(tagsByClusterId)
    .flat()
    .sort((a, b) => sortAlphaBeta(a.label, b.label)),
);

export const selectTagColorItems = createSelector([selectSortedTags], (crops) => {
  return crops
    .filter((crop) => !!crop.color)
    .map((crop): ColorItem => ({
      id: String(crop.id),
      name: crop.label,
      color: getColorWithHash(crop.color),
    }));
});
